<template>
	<div class="stamp-condition">
		<InputText
			:propValue="date"
			mode="number"
			class="stamp-condition__date"
			@input="dateInput"
		/>
		일
		<TextCounter
			:value="title"
			:maxLength="13"
			class="stamp-condition__title"
			@input="titleInput"
		/>
		<InputText
			:propValue="headcount"
			mode="number"
			class="stamp-condition__headcount"
			@input="headcountInput"
		/>
		명
		<VIcon
			v-if="deletable"
			class="stamp-condition__delete-button"
			v-text="'mdi-minus-circle'"
			@click="deleting"
		/>
		<VIcon
			v-if="addable"
			class="stamp-condition__add-button"
			v-text="'mdi-plus-circle'"
			@click="adding"
		/>
	</div>
</template>
<script>
	import InputText from '@/components/InputText.vue';
	import TextCounter from '@/components/TextCounter.vue';

	export default {
		name: 'StampConditionItem',
		components: {
			InputText,
			TextCounter,
		},
		props: {
			id: {
				type: [String, Number],
				required: true,
			},
			date: {
				type: String,
				default: '',
			},
			title: {
				type: String,
				default: '',
			},
			headcount: {
				type: String,
				default: '',
			},
			deletable: {
				type: Boolean,
				default: false,
			},
			addable: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			dateInput(date) {
				this.$emit('input', {
					id: this.id,
					date,
				});
			},
			titleInput(title) {
				this.$emit('input', {
					id: this.id,
					title,
				});
			},
			headcountInput(headcount) {
				this.$emit('input', {
					id: this.id,
					headcount,
				});
			},
			deleting() {
				this.$emit('delete', this.id);
			},
			adding() {
				this.$emit('add');
			},
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-condition {
		display: flex;
		width: 100%;
		height: 40px;
		align-items: center;

		&__date {
			margin-right: 8px;
		}

		&__title {
			margin-left: 16px;
		}

		&__headcount {
			margin-left: 16px;
			margin-right: 8px;
		}

		&__delete-button {
			margin-left: 8px;
			color: red;
		}

		&__add-button {
			margin-left: 8px;
			color: green;
		}
	}
</style>
